
export default {
  name: "Select",

  data: function () {
    return {
      isOpen: false
    }
  },

  props: {
    value: {
      type: [String, Object],
      default: null
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: "Выберите"
    }
  },

  computed: {
    selectValue: function () {
      const _selectedOptions = (this.options || []).find((t) => Boolean(String(t.value) === String(this.value)));
      if (!!_selectedOptions) {
        return _selectedOptions?.label || ""
      }

      return this.value?.label || this.value || this.placeholder || ""
    }
  },

  methods: {
    onOpen: function () {
      this.isOpen = true;
    },
    onClose: function () {
      this.isOpen = false;
    },

    onSelect: function (item) {
      this.$emit("change", item);
      this.onClose();
    }
  }
}
